/**
 * Visual collections mega menu — category tabs (desktop).
 * Mobile nested panels reuse menu-drawer.js.
 */
(function () {
  'use strict';

  function activateCat(root, button) {
    if (!root || !button) return;
    var targetId = button.getAttribute('data-visual-mega-target');
    if (!targetId) return;

    root.querySelectorAll('[data-visual-mega-cat]').forEach(function (cat) {
      var selected = cat === button;
      cat.classList.toggle('is-active', selected);
      cat.setAttribute('aria-selected', selected ? 'true' : 'false');
      cat.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-visual-mega-panel]').forEach(function (panel) {
      var match = panel.id === targetId;
      panel.classList.toggle('is-active', match);
      if (match) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });

    var view = root.querySelector('[data-visual-mega-view]');
    var url = button.getAttribute('data-visual-mega-url');
    var label = button.getAttribute('data-visual-mega-label');
    if (view) {
      if (url) view.setAttribute('href', url);
      if (label) {
        var labelEl = view.querySelector('.visual-mega__view-all-text');
        if (labelEl) labelEl.textContent = label;
      }
    }
  }

  /* Hover switches product panel; click follows the category href. */
  function onCatMouseOver(event) {
    var button = event.target.closest('[data-visual-mega-cat]');
    if (!button) return;
    if (button.contains(event.relatedTarget)) return;
    var root = button.closest('[data-visual-mega-menu]');
    if (!root) return;
    var details = root.closest('.header__nav-details');
    if (!details || !details.open) return;
    if (button.classList.contains('is-active')) return;
    activateCat(root, button);
  }

  function onCatKeydown(event) {
    var button = event.target.closest('[data-visual-mega-cat]');
    if (!button) return;
    var root = button.closest('[data-visual-mega-menu]');
    if (!root) return;

    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-visual-mega-cat]'));
    var index = cats.indexOf(button);
    if (index < 0) return;

    var next = -1;
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % cats.length;
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + cats.length) % cats.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = cats.length - 1;

    if (next < 0) return;
    event.preventDefault();
    cats[next].focus();
    activateCat(root, cats[next]);
  }

  document.addEventListener('mouseover', onCatMouseOver);
  document.addEventListener('keydown', onCatKeydown);
})();
